export default __webpack_public_path__ + "static/media/petal_SocialHealth.4b92185f.svg";